import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { OPPORTUNITY_SOURCES } from "@/api/types";
import { AnalyticsPage } from "@/features/analytics/analytics-page";

export const Route = createFileRoute("/_authenticated/$store/analytics/")({
  validateSearch: z.object({
    range: z.enum(["7d", "30d", "90d"]).optional().catch(undefined),
    source: z.enum(OPPORTUNITY_SOURCES).optional().catch(undefined),
    buyer: z.string().optional().catch(undefined),
  }),
  head: () => ({ meta: [{ title: "Analytics · Rogue AI" }] }),
  component: AnalyticsPage,
});
